/* stylelint-disable max-nesting-depth, selector-max-compound-selectors */
sew-ws-tabs {
    display: block;
    position: relative;

    &:not([no-margin]) {
        @include component-spacing;
    }

    &:not([no-grid]) {
        @include grid;
    }

    h2 {
        @include typo-ws-h2;

        margin: 0;

        + .tabs-nav-container {
            margin-top: 40px;
        }
    }

    > .main-content-container {
        display: grid;
        grid-template-columns: 1fr;
    }

    // Preventing a Grid Blowout
    // https://css-tricks.com/preventing-a-grid-blowout/
    .tabs-wrapper {
        min-width: 0;
    }

    .tabs-nav-container {
        position: relative;
        overflow: hidden;

        > .scroll-btn {
            position: absolute;
            top: 0;
            border-width: 0;
            z-index: 1;
            padding: 0;
            color: $color-grey-01-dark;
            background-color: transparent;
            cursor: pointer;

            &.--hide {
                display: none;
            }

            &--left {
                left: -9px;

                &::before {
                    content: '';
                    pointer-events: none;
                    position: absolute;
                    top: 0;
                    left: 18px;
                    width: 50px;
                    height: 100%;
                    background: linear-gradient(to left, rgba($color-white, 0) 0%, rgba($color-white, 1) 80%);
                }
            }

            &--right {
                right: -9px;

                &::before {
                    content: '';
                    pointer-events: none;
                    position: absolute;
                    top: 0;
                    right: 18px;
                    width: 50px;
                    height: 100%;
                    background: linear-gradient(
                        to right,
                        rgba($color-white, 0) 0%,
                        rgba($color-white, 1) 80%
                    );
                }
            }

            .svg {
                background-color: $color-white;
                display: block;
            }
        }
    }

    .tabs-nav {
        @include typo-ws-h4;

        display: flex;
        gap: 40px;
        position: relative;
        scroll-behavior: smooth;
        list-style: none;
        margin: 0;
        padding: 0;
        overflow-x: scroll;
        white-space: nowrap;
        user-select: none;
        -ms-overflow-style: none;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }

        .tab {
            display: inline-block;
            scroll-snap-align: center;
            cursor: pointer;

            &.--active {
                color: $color-red;
            }
        }
    }

    .tab-content {
        margin-top: 20px;
        border-top: 5px solid $color-grey-01-dark;
        border-bottom: 2px solid $color-grey-01-dark;
    }

    .button-wrapper {
        display: flex;
        gap: 20px;
        margin-top: 40px;
    }
}

sew-ws-tabs[no-content] {
    .tabs-nav {
        gap: 20px;
    }

    .tab-content {
        display: none;
    }
}

@include mq-1 {
    sew-ws-tabs {
        > h2 {
            margin-bottom: 32px;
        }
        .button-wrapper {
            flex-direction: column;
        }
    }
}

@media print {
    sew-ws-tabs {
        .tab-content {
            margin-top: 0;
            border-top: 0;
            border-bottom: 0;
        }

        .button-wrapper {
            display: none;
        }

        .tabs-nav-container {
            display: none;
        }

        > sew-ws-tabs-item:first-child {
            margin-top: 40px;
        }

        > sew-ws-tabs-item {
            margin-top: 60px;
        }
    }
}
